import { ReadOutlined, RocketOutlined, TeamOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { GroupAvatar } from '@/components'
import { useGetUserTaleUsageQuery } from '@/generated/graphql'
import { routes } from '@/routes'

import s from './user-sidebar.module.less'

export interface UserSidebarProps {
  userId: number
  getHeader: (icon: React.ReactNode, title: React.ReactNode) => React.ReactNode
}

export const UserSidebarTaleUsage: React.FC<UserSidebarProps> = ({ userId, getHeader }) => {
  const [t] = useTranslation()
  const limit = 5

  const { data } = useGetUserTaleUsageQuery({
    variables: {
      userId,
      limit,
      pagination: {
        last: limit,
      },
    },
  })

  if (!data) {
    return null
  }

  const posts = data.user.featuredPosts?.edges.map(({ node }) => node)

  const groups = data.user.activeGroups

  const knowledge = data.user.contributedKnowledge?.edges.map(({ node }) => node)

  const featuredPosts = posts?.length > 0 && (
    <div className={s.description}>
      {getHeader(<RocketOutlined style={{ marginRight: 8 }} />, <span>{t('userCard.featured')}</span>)}
      <div className={s.contents}>
        {posts.map((p) => (
          <div key={p.postId} className={s.itemWithoutField}>
            <Link className={s.postContent} to={routes.posts.page(p.postId)}>
              {p.content.trim().length === 0 ? '[分享]' : p.content.trim().substring(0, 100)}
            </Link>
          </div>
        ))}
      </div>
    </div>
  )

  const activeGroups = groups.length > 0 && (
    <div className={s.description}>
      {getHeader(<TeamOutlined style={{ marginRight: 8 }} />, <span>{t('profile.taleUsage.activeGroups')}</span>)}
      <div className={s.contents}>
        {groups.map((g) => (
          <div key={g.groupId} className={s.itemWithoutField}>
            <GroupAvatar style={{ fontSize: 20, marginRight: 8 }} groupCatId={g.category?.groupCategoryId} />
            <Link to={routes.groups.page(g.groupId)}>{g.name}</Link>
          </div>
        ))}
      </div>
    </div>
  )

  const contributedKnowledge = knowledge && knowledge.length > 0 && (
    <div className={s.description}>
      {getHeader(<ReadOutlined style={{ marginRight: 8 }} />, <span>{t('userCard.contributedKnowledge')}</span>)}
      <div className={s.contents}>
        {knowledge.map((k) => (
          <div key={k.knowledgePostId} className={s.itemWithoutField}>
            <Link to={routes.knowledgebase.knowledge(k.knowledgePostId)}>{k.title}</Link>
          </div>
        ))}
      </div>
    </div>
  )

  return (
    <>
      {featuredPosts}
      {contributedKnowledge}
      {activeGroups}
    </>
  )
}
